<nz-layout class="app-layout">
  <nz-spin [nzIndicator]="indicatorTemplate" [nzSpinning]="isLoading$ | async">
    <app-sidebar [(isCollapsed)]="isCollapsed"></app-sidebar>
    <nz-layout class="main-content" [class.collapsed]="isCollapsed">
      <nz-header class="header-container" [class.collapsed]="isCollapsed">
        <app-header></app-header>
      </nz-header>
      <nz-content>
        <div class="inner-content">
          <router-outlet></router-outlet>
        </div>
      </nz-content>
    </nz-layout>
  </nz-spin>
</nz-layout>
<ng-template #indicatorTemplate>
  <nz-icon nzType="loading" class="loading-icon !text-primary-main"></nz-icon>
</ng-template>
